import TransferWarning from './TransferWarning';

export default TransferWarning;
